import "./AddCar.css";
import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import axiosInstance from "../../axiosInstance";

const AddCar = () => {
    const [formData, setFormData] = useState({
        carColor: "",
        carNumber: "",
        carModel: "",
    });
    
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    
    const handleAddCar = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            const response = await axiosInstance.post("/cars/add", formData, {
                headers: { Authorization: token },
            });
            if (response.status === 200 && response.data.success) {
                console.log("Car added successfully");
                setFormData({ carColor: "", carNumber: "", carModel: "" });
            } else {
                console.error("Error adding car: ", response.data.error);
            }
        } catch (error) {
            console.error("Failed to add car: ", error);
        }
    };

    return (
        <ContentWrapper>
            <Container fluid>
                <Breadcrumb>
                    <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                    <Breadcrumb.Item active>Add Car</Breadcrumb.Item>
                </Breadcrumb>
                <section className="section-padding">
                    <Row>
                        <Form className="col-lg-12 col-md-12 cnt_frm add_Cr" noValidate onSubmit={handleAddCar}>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <Form.Group controlId="car-color">
                                        <Form.Label>Car Color</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="carColor"
                                            placeholder="Enter Car Color"
                                            value={formData.carColor}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Form.Group controlId="car-number">
                                        <Form.Label>Car Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="carNumber"
                                            placeholder="Enter Car Number"
                                            value={formData.carNumber}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <Form.Group controlId="car-model">
                                        <Form.Label>Car Model</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="carModel"
                                            placeholder="Enter Car Model"
                                            value={formData.carModel}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Button variant="primary" className="mt-3 addcr" type="submit">
                                Add Car
                            </Button>
                        </Form>
                    </Row>
                </section>
            </Container>
            <ThinFooter />
        </ContentWrapper>
    );
};

export default AddCar;
